<template>
  <v-card class="ma-3">
    <base-loading v-if="loading" />
    <crud-list
      v-else
      v-model="providers"
      :headers="headers"
      :slots="['item.Tipo', 'item.ATIVO']"
      :actions="actions"
      @itemsFiltered="handleListFiltered"
    >
      <template
        v-if="$user.get().role == 'gestor' || $user.get().role == 'consultoria'"
        v-slot:btnCadastro
      >
        <v-row>
          <v-col>
            <v-btn
              color="green darken-1"
              dark
              class="rounded-lg"
              :loading="loadingSheet"
              @click="exportSheet"
            >
              <v-icon class="mr-2">mdi-file-excel</v-icon>

              <span style="font-size: 16px; font-weight: 600">Exportar</span>
            </v-btn>
          </v-col>
          <v-col>
            <router-link :to="`/${$user.get().role}/prestador/form`">
              <v-btn color="success"> Novo prestador </v-btn>
            </router-link>
          </v-col>
        </v-row>
      </template>
      <template v-slot:[`item.ATIVO`]="{ item }">
        <v-btn
          v-if="item.ATIVO === 'Ativo' || item.ATIVO === 1"
          rounded
          small
          plain
          text
          class="teal lighten-1 white--text"
          @click="updateStatus(item)"
          >{{ item.ATIVO }}</v-btn
        >
        <v-btn
          v-else
          text
          rounded
          small
          plain
          class="red lighten-1 white--text"
          @click="updateStatus(item)"
          >{{ item.ATIVO }}</v-btn
        >
      </template>
      <template v-slot:[`item.Tipo`]="{ item }">
        {{ typeProvider(item.Tipo) }}
      </template>
    </crud-list>
  </v-card>
</template>

<script>
import { JsonToExcel } from '../../utils/Worksheet'

export default {
  data() {
    return {
      actions: [
        {
          title: 'Editar prestador',
          color: 'yellow darken-3',
          click: item =>
            this.$router.push({
              path: `/${this.$user.get().role}/prestador/form`,
              query: {
                id: item.id,
              },
            }),
          icon: 'mdi-pencil',
        },
        {
          title: 'Inativar prestador',
          color: 'red darken-3',
          click: item => this.deleteItem(item),
          icon: 'mdi-delete',
        },
      ],
      providers: [],
      listFiltered: [],
      loading: true,
      loadingSheet: false,
      headers: [
        {
          text: '',
          sortable: false,
          width: '80px',
          value: 'actions',
          align: 'left',
        },
        {
          text: 'Status',
          sortable: true,
          width: 'auto',
          value: 'ATIVO',
          align: 'left',
          filterable: true,
        },
        {
          text: 'Nome / Nome Fantasia',
          align: 'left',
          sortable: true,
          value: 'Nome',
          width: 'auto',
          filterable: true,
        },
        {
          text: 'Email',
          align: 'left',
          sortable: true,
          value: 'Email',
          width: 'auto',
          filterable: true,
        },
        {
          text: 'CPF / CNPJ',
          align: 'left',
          sortable: true,
          value: 'CPF_CNPJ',
          width: 'auto',
        },
        {
          text: 'Tipo',
          align: 'left',
          sortable: true,
          value: 'Tipo',
          width: 'auto',
        },
      ],
    }
  },
  created() {
    this.getProviders()
  },
  methods: {
    handleListFiltered(value) {
      this.listFiltered = value
    },
    typeProvider(tipo) {
      if (tipo) return 'Pessoa Física'
      return 'Pessoa Jurídica'
    },
    getProviders() {
      this.api.get.prestadores(null, true).then(data => {
        data = data.map(item => {
          item.ATIVO = this.typeState(item.ATIVO)
          return item
        })
        this.providers = data
        this.loading = false
      })
    },

    updateStatus(item) {
      if (
        this.$user.get().role === 'admin' ||
        this.$user.get().role === 'consultoria'
      ) {
        this.Swal.fire({
          title: `${item.ATIVO === 'Ativo' ? 'Inativar' : 'Ativar'} Prestador`,
          text: `Tem certeza que deseja ${
            item.ATIVO === 'Ativo' ? 'inativar' : 'ativar'
          } este prestador?`,
          icon: 'question',
          showCancelButton: true,
          confirmButtonColor: '#ff5252',
          confirmButtonText: `Sim, desejo ${
            item.ATIVO === 'Ativo' ? 'inativar' : 'ativar'
          }!`,
          cancelButtonText: 'Cancelar',
          preConfirm: () => {
            this.api.update
              .prestadorState(item.id, {
                state: item.ATIVO === 'Ativo' ? 0 : 1,
              })
              .then(res => {
                this.providers = this.providers.map(prestador => {
                  if (prestador.id === item.id) {
                    prestador.ATIVO =
                      item.ATIVO === 'Ativo' ? 'Inativo' : 'Ativo'
                  }
                  return prestador
                })
                this.Swal.fire({
                  title: 'Sucesso',
                  text: `Prestador ${
                    res.ATIVO ? 'ativado' : 'inativado'
                  } com sucesso`,
                  icon: 'success',
                  showConfirmButton: false,
                  timer: 2000,
                })
              })
            return true
          },
        })
      } else {
        this.Swal.fire(
          'Não permitido!',
          'Somente o Admin pode alterar o Status dos Prestadores.',
          'error',
        )
      }
    },

    typeState(status) {
      if (status == '1') {
        return 'Ativo'
      } else {
        return 'Inativo'
      }
    },
    exportSheet() {
      this.loadingSheet = true

      new JsonToExcel(
        this.listFiltered,
        this.headers,
        'prestadores.xlsx',
        'Prestadores',
      )

      this.loadingSheet = false
    },
    deleteItem(item) {
      this.Swal.fire({
        icon: 'error',
        title: 'Inativar Prestador',
        text: 'Você tem certeza que deseja inativar este prestador?',
        showCancelButton: true,
        confirmButtonColor: '#f74242',
        confirmButtonText: 'SIM, INATIVAR',
        cancelButtonText: 'NÃO',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return this.api.delete.prestador(item.id).then(
            () => {
              return 1
            },
            reject => {
              return reject
            },
          )
        },
        allowOutsideClick: () => !this.Swal.isLoading(),
      }).then(result => {
        if (result.value === 1) {
          this.loading = true
          this.getProviders()
          this.Swal.fire({
            title: 'Sucesso',
            text: 'O prestador foi inativado com sucesso!',
            icon: 'success',
            showConfirmButton: false,
            timer: 2000,
          })
        }
      })
    },
  },
}
</script>
